import appStore from 'store';
import api from './api';
import { STATUS_TYPE } from './constants';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    merchants: [],
    totalCount: 0,
    coinLists: []
  },
  getters: {},
  mutations: {
    setMerchantList(state, payload) {
      state.merchants = payload.list.concat();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinlist(state, payload) {
      state.coinLists = payload;
    }
  },
  actions: {
    listMerchants({ commit }, query) {
      api.listMerchants(query).then(({ data }) => {
        commit('setMerchantList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    createMerchant(context, data) {
      return api.createMerchant(data);
    },
    removeMerchant(context, data) {
      return api.removeMerchant(data);
    },
    getCoinList({ commit }, datas) {
      api.getCoinList(datas).then(({ data }) => {
        commit('setCoinlist', data);
      });
    },
    addCoin(context, data) {
      return api.addCoin(data);
    },
    deleteCoin(context, data) {
      return api.deleteCoin(data);
    }
  }
};

appStore.registerModule('merchant', store);
